import AllPostingsPage from "./AllPostings"
import DiscrepanciesPostingsPage from "./DiscrepanciesPostings"
import DokupPostingsPage from "./DokupPostings"
import OrdersPage from "./Orders"
import OrderPage from "./Orders/Order"
import PackagingPage from "./Packaging"
import PostingPage from "./Posting"
import ShipmentPage from "./Shipment"
import ShipmentsPage from "./Shipments"
import SortingPage from "./Sorting"
import SuppliesPage from "./Supplies"
import SuppliesStatisticPage from "./SuppliesStatistic"
import SupplyPage from "./Supply"
import WbStoragePage from "./WbStorage"
import WbFbs from "./WbFbs"

const ShipmentPages = {
    Order: OrderPage,
    Orders: OrdersPage,

    Supplies: SuppliesPage,
    SuppliesStatistic: SuppliesStatisticPage,
    Supply: SupplyPage,
    // WbFbs: WbFbs,

    WbStoragePage: WbStoragePage,

    Shipments: ShipmentsPage,
    Shipment: ShipmentPage,
    Posting: PostingPage,

    Packaging: PackagingPage,
    Sorting: SortingPage,

    AllPostings: AllPostingsPage,
    DiscrepanciesPostings: DiscrepanciesPostingsPage,
    DokupPostings: DokupPostingsPage,
}

export default ShipmentPages